import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Channels from "./MasterSettings/Channels";
import PaymentMethod from "./MasterSettings/PaymentMethod";
import Sales from "./MasterSettings/Sales";
import ServicePeriod from "./MasterSettings/ServicePeriod";

const MasterSettings = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div
      className="tab-pane fade show active"
      id="nav-mastersetting"
      role="tabpanel"
      aria-labelledby="nav-mastersetting"
    >
      <div className="row mx-0">
        <div className="container px-0">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            <PaymentMethod />

            <Sales />

            <ServicePeriod />

            <Channels />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MasterSettings;
